/**
 * @generated SignedSource<<6929dd1061acff6c9235a97189f829ba>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PdpRespDetailTabs_viewer$data = {
  readonly " $fragmentSpreads": FragmentRefs<"PdpRespDealerDetails_viewer" | "getPdpEstimateSimilarSold_viewer">;
  readonly " $fragmentType": "PdpRespDetailTabs_viewer";
};
export type PdpRespDetailTabs_viewer$key = {
  readonly " $data"?: PdpRespDetailTabs_viewer$data;
  readonly " $fragmentSpreads": FragmentRefs<"PdpRespDetailTabs_viewer">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PdpRespDetailTabs_viewer",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpRespDealerDetails_viewer"
    },
    {
      "kind": "InlineDataFragmentSpread",
      "name": "getPdpEstimateSimilarSold_viewer",
      "selections": [
        {
          "kind": "InlineDataFragmentSpread",
          "name": "getHasEnoughSimilarSoldItems_viewer",
          "selections": [
            {
              "condition": "isEstimateSimilarSoldVariant",
              "kind": "Condition",
              "passingValue": true,
              "selections": [
                {
                  "alias": "similarSoldItemsResults",
                  "args": [
                    {
                      "kind": "Literal",
                      "name": "first",
                      "value": 0
                    },
                    {
                      "kind": "Variable",
                      "name": "itemId",
                      "variableName": "itemId"
                    }
                  ],
                  "concreteType": "SimilarSoldItemsConnection",
                  "kind": "LinkedField",
                  "name": "similarSoldItems",
                  "plural": false,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "totalResults",
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                }
              ]
            }
          ],
          "args": null,
          "argumentDefinitions": [
            {
              "kind": "RootArgument",
              "name": "isEstimateSimilarSoldVariant"
            },
            {
              "kind": "RootArgument",
              "name": "itemId"
            }
          ]
        }
      ],
      "args": null,
      "argumentDefinitions": []
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};

(node as any).hash = "b061d925f79c705fa43c30b34dfca25d";

export default node;
